import React, { Component } from "react";
import { VictoryAnimation, VictoryLabel, VictoryPie } from 'victory';
import "../../css/utils/ProgressBarSquare.css";

export default class ProgressBarSquare extends Component {
    constructor() {
       super();
       this.state = {
           percent: 0
       };
     }

     componentDidMount(){
         
     }

     componentWillUnmount() {

     }

     render() {
         var message = this.props.message;
       return (
         <div className="prograssBarSquareBkgrd">
             <div className="prograssBarSquareBkgrd_title">
                <span className="glyphicon glyphicon-bullhorn"></span>
                &nbsp;
                Progress status
             </div>
             <div className="prograssBarSquareBkgrd_message">
                 { message }
             </div>
         </div>
       );
     }
}



// WEBPACK FOOTER //
// ./src/components/utils/ProgressBarSquare.js